import React , { useContext, useEffect, useState } from "react";
import { Badge, Button, Checkbox, Col, Collapse, Divider, InputNumber, message, Modal, Row, Select, TimePicker, Typography, Switch, Tooltip, Table, TreeSelect } from "antd";
import './new-timing.style.scss';
import { getScheduleStopsByTripIdWithCities, resetToDefaultTimings, updateStopTimingsOfTrip, getTicketAlertContentForResetStops, getStopBookingConflictsForFutureDates } from "../../../actions/home.action";
import { checkActionAllowed, deleteIndexValue, getArrayfromString, isValid, isValidArray, isValidNumber } from "../../../utils/utilities";
import { getReadableDate, getTimeStampInReadableFormat, getAPIDateFormat } from "../../../utils/date.utils";
import TicMarkIcon from './../../../images/tic-mark.png';
import Icon from '@ant-design/icons';
import { showConfirm } from "../../custom-components/custom-component";
import { loadingAction } from "../../../actions/loading-actions";
import { useDispatch } from "react-redux";
import { UPDATE_IN_NEW_TIME_TAB } from "../../../utils/constant";
import moment from "moment";
import ZoomComponent from './../../custom-components/zoom-component/zoom.component';
import { DeviceContext } from "../../device-provider/device-provider";
import {
    MinusSquareOutlined,
    MinusSquareFilled,
    PlusSquareOutlined,
    EditOutlined,
    DeleteOutlined,
    CheckSquareFilled,
    PlusOutlined,
    EnvironmentOutlined
} from '@ant-design/icons';
import { getAddressLocations } from "../../../actions/trip-create.actions";
import { CreateStandardStopsPage } from "../../../pages/create-standard-stop.page";
import { ScheduleCalendar } from '../../shared/schedule-calendar/schedule-calendar.component';
import { MultiDayFareCalendar } from '../../edit-fare-component/multi-day-fare-calendar.component';

const { 
    Panel
} = Collapse;

const {
    Title ,
    Text
} = Typography ;

const {
    Option
} = Select;

const getExistingLocations=(stopsWithCities)=>{
    let locations = [];
    if(isValidArray(stopsWithCities)){
        for (let index = 0; index < stopsWithCities.length; index++) {
            const element = stopsWithCities[index];
            let {
                stops
            } = element;
            for (let index = 0; index < stops.length; index++) {
                const stop = stops[index];
                locations.push(stop.displayName);
            }
        }
        return locations;
    }else{
        return [];
    }
}

const showResetBtn=(citiesWithStops)=>{
    let atleastonepointedited = false;
    citiesWithStops.forEach((cityObject)=>{

        cityObject.stops.forEach((stopObject)=>{
            
            if(stopObject.isEdit == true || stopObject.isActive == 0){
                atleastonepointedited = true;
            }

           
        })
    });
    return atleastonepointedited;
}

const showCheckBoxForEdit=()=>{
    if(checkActionAllowed(UPDATE_IN_NEW_TIME_TAB)){
        return true;
    }else{
        return false;
    }
}



const getChangedStops = (citiesWithStops) => {
    const changedStops = {};
    let firstActiveCity = null;
    let lastActiveCity = null;
    let firstCityStartTime = null;
    let lastCityEndTime = null;
    
    citiesWithStops.forEach((currentCity) => {
        const cityName = currentCity.displayName;
        let allStopsInactive = true;        
        
        // Find main stop or first active stop for city timing
        const mainStop = currentCity.stops.find(stop => stop.isMainStop);
        const firstActiveStop = currentCity.stops.find(stop => stop.isActive);
        const cityTimingStop = mainStop || firstActiveStop;
        // Get city day from main/first active stop
        const cityDay = cityTimingStop?.day || 0;

        // Process stops
        const cityStopChanges = {};
        currentCity.stops.forEach((currentStop) => {
            if (currentStop.isActive) {
                allStopsInactive = false;
                // Assign first active city if not already assigned
                if (!firstActiveCity) {
                    firstActiveCity = currentCity.city;
                    firstCityStartTime = cityTimingStop.timing;                    
                }
                // Always update last active city
                lastActiveCity = currentCity.city;
                lastCityEndTime = currentStop.timing;
            }

            // Validate stop day against city day
            if (currentStop.day < cityDay) {
                throw new Error(`The day of stop "${currentStop.displayName}" cannot be before the day of main stop of city "${cityName}"`);
            }
            
            const stopChanges = {
                timing: currentStop.timing,
                day: Math.max(currentStop.day - cityDay, 0), // Subtract city day from stop day
                isActive: Boolean(currentStop.isActive),
                tripClosePoint: currentStop.tripClosePoint || 0,
                isMainStop: currentStop.isMainStop || false,
                isBoarding: currentStop.isBoarding || false,
                isDrop: currentStop.isDrop || false,
                selectedStopId: currentStop.selectedStopId,
                phoneNumber: currentStop.phoneNumber,
                landlineNumber: currentStop.landlineNumber,
                originalPickupId: currentStop.originalPickupId,
                originalDropId: currentStop.originalDropId
            };

            // Add new stop specific fields
            // Note day specific stops to handle for permanent changes only when stop is active to copy stop to other days
            // isPermanentChange
            if (currentStop.isNewStop || (currentStop.isDaySpecificStop&&currentStop.isActive)) {
                Object.assign(stopChanges, {
                    isNewStop: true,
                    selectedStopId: currentStop.selectedStopId,
                    phoneNumber: currentStop.phoneNumber,
                    landlineNumber: currentStop.landlineNumber,
                    isBoarding: currentStop.isBoarding || false,
                    isDrop: currentStop.isDrop || false,
                    isMainStop: currentStop.isMainStop || false
                });
            }

            cityStopChanges[currentStop.displayName] = stopChanges;

            const cityChanges = {
                timing: cityTimingStop?.timing || null,
                day: Math.max(cityTimingStop?.day || 0, 0),
                isActive: !allStopsInactive,
                routeIds: currentCity.routeIds || []
            };

            changedStops[cityName] = {
                city: cityChanges,
                stops: cityStopChanges
            };
        });
    });

    return { changedStops, firstActiveCity, lastActiveCity ,firstCityStartTime,lastCityEndTime};
};

const getCityTimingStop = (city) => {
    if (!city || !isValidArray(city.stops)) return null;
    return city.stops.find(stop => stop.isMainStop) || city.stops.find(stop => stop.isActive) || null;
};

const formatMinutesAsDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const parts = [];
    if (hours > 0) parts.push(`${hours} ${hours === 1 ? 'hr' : 'hrs'}`);
    if (minutes > 0) parts.push(`${minutes} ${minutes === 1 ? 'min' : 'mins'}`);
    return parts.join(' ');
};

// The origin's timing is sent to the backend as the trip start time without a day,
// so the main stop of the first active (origin) city has to stay on Day 1. Returns
// an error message when it has been pushed to Day 2 or later, otherwise null.
const getOriginMainStopDayError = (citiesWithStops, originalStops = []) => {
    if (!isValidArray(citiesWithStops)) return null;
    const originCity = citiesWithStops.find(city => isValidArray(city.stops) && city.stops.some(stop => stop.isActive));
    if (!originCity) return null;
    const originStop = getCityTimingStop(originCity);
    if (!originStop) return null;
    const originDay = isValidNumber(originStop.day) ? originStop.day : 0;
    if (originDay <= 0) return null;

    let errMsg = `Main stop "${originStop.displayName}" of origin city "${originCity.displayName}" cannot be moved to Day ${originDay + 1}. It must stay on Day 1.`;

    // Tell the user how far the original time can be pushed before it crosses midnight
    // (e.g. original 10:00 PM -> less than 2 hrs).
    const originalCity = isValidArray(originalStops) ? originalStops.find(city => city.displayName === originCity.displayName) : null;
    const originalStop = getCityTimingStop(originalCity);
    if (originalStop && isValid(originalStop.timing) && !(originalStop.day > 0)) {
        const [hours, minutes] = originalStop.timing.split(':').map(Number);
        const minutesToMidnight = (24 * 60) - ((hours * 60) + minutes);
        if (minutesToMidnight > 0) {
            errMsg += ` Its original time is ${getTimeStampInReadableFormat(originalStop.timing)}, so it can be moved ahead by less than ${formatMinutesAsDuration(minutesToMidnight)}.`;
        }
    }
    return errMsg;
};

const TimePickerComponent = ({ value, onSelect, showError, timeExits, isMobile }) => (
    <TimePicker 
        size={isMobile ? "small" : "small"}
        className={`${showError && !timeExits ? "remove-clear-icon errorInput" : "remove-clear-icon"} ${isMobile ? "mobile-time-picker" : ""}`}
        popupClassName={isMobile ? "mobile-time-picker-popup time-picker-to-not-display-footer" : "time-picker-to-not-display-footer"}
        use12Hours 
        format='h:mm A'  
        minuteStep={5} 
        value={isValid(value) ? moment(value, 'HH:mm') : null}
        onSelect={onSelect}
        style={{ width: '100%' }}
    />
);

const StopNameDisplay = ({ displayName, isBoarding, isDrop }) => (
    <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap'  }}>
        {displayName}
        {(isBoarding || isDrop) && (
            <span style={{ marginLeft: '4px' }}>
                {isBoarding && (
                    <span style={{ 
                        backgroundColor: '#1890ff',
                        color: 'white',
                        padding: '0 4px',
                        borderRadius: '2px',
                        fontSize: '12px',
                        marginRight: '4px'
                    }}>
                        B
                    </span>
                )}
                {isDrop && (
                    <span style={{ 
                        backgroundColor: '#52c41a',
                        color: 'white',
                        padding: '0 4px',
                        borderRadius: '2px',
                        fontSize: '12px'
                    }}>
                        D
                    </span>
                )}
            </span>
        )}
    </span>
);

const CityCheckbox = ({ isActive, cityIndex, onToggle, isShowCheckBox=true }) => {
    if (!isShowCheckBox) return null;

    const handleClick = (e) => {
        // Prevent event from bubbling up to parent elements
        e.stopPropagation();
        onToggle(!isActive, cityIndex);
    };

    if (!isActive) {
        return (
            <MinusSquareFilled 
                className="marginRight"
                style={{ 
                    color: '#ff4d4f',
                    fontSize: '18px',
                    cursor: 'pointer'
                }}
                onClick={handleClick}
            />
        );
    }

    return (
        <CheckSquareFilled 
            className="marginRight default-checkbo-btn"
            style={{ 
                fontSize: '18px',
                cursor: 'pointer'
            }}
            onClick={handleClick}
        />
    );
};


// Build TreeSelect data with each city as a (non-selectable) parent node and its
// stops as selectable leaves. Each leaf's value is the stop's global, route-ordered
// index so the range logic stays index based. `minIndex` filters out leaves that
// come before it (used by the "to stop" tree to keep the range valid).
const getStopTreeData = (citiesWithStops, minIndex = 0) => {
    const treeData = [];
    let globalIndex = -1;
    if (isValidArray(citiesWithStops)) {
        citiesWithStops.forEach((city, cityIdx) => {
            const children = [];
            if (isValidArray(city.stops)) {
                city.stops.forEach(stop => {
                    globalIndex += 1;
                    if (globalIndex >= minIndex) {
                        children.push({
                            title: stop.displayName,
                            value: globalIndex,
                            key: globalIndex
                        });
                    }
                });
            }
            if (children.length > 0) {
                treeData.push({
                    title: city.displayName || city.city,
                    value: `city-${cityIdx}`,
                    key: `city-${cityIdx}`,
                    selectable: false,
                    children
                });
            }
        });
    }
    return treeData;
};

// Total number of stops across all cities (used to default the range to first -> last).
const getTotalStopCount = (citiesWithStops) => {
    let count = 0;
    if (isValidArray(citiesWithStops)) {
        citiesWithStops.forEach(city => {
            if (isValidArray(city.stops)) {
                count += city.stops.length;
            }
        });
    }
    return count;
};

const TimeAdjustmentModal = ({ visible, onClose, onApply, citiesWithStops }) => {
    const [operation, setOperation] = useState('+');
    const [minutes, setMinutes] = useState(0);
    const [fromStop, setFromStop] = useState(null);
    const [toStop, setToStop] = useState(null);

    const totalStops = getTotalStopCount(citiesWithStops);

    // Default the range to the whole route: first stop -> last stop.
    useEffect(() => {
        if (visible && totalStops > 0) {
            setFromStop(0);
            setToStop(totalStops - 1);
        }
    }, [visible, totalStops]);

    return (
        <Modal
            title="Adjust Timings"
            className="adjust-timings-modal"
            visible={visible}
            onCancel={onClose}
            onOk={() => {
                if (onApply(operation, minutes, fromStop, toStop) !== false) {
                    onClose();
                }
            }}
            okText="Apply"
        >
            <div className="adjust-timings-body">
                <div className="adjust-timings-range">
                    <div className="adjust-timings-field">
                        <label className="adjust-timings-label">From stop</label>
                        <TreeSelect
                            className="adjust-timings-tree"
                            dropdownClassName="adjust-timings-tree-dropdown"
                            placeholder="Select from stop"
                            value={fromStop}
                            treeDefaultExpandAll
                            showSearch
                            filterTreeNode={(input, node) => node.title.toLowerCase().includes(input.toLowerCase())}
                            treeData={getStopTreeData(citiesWithStops)}
                            onChange={(value) => {
                                setFromStop(value);
                                // Keep the range valid: to-stop can't precede from-stop.
                                if (!isValidNumber(toStop) || toStop < value) {
                                    setToStop(value);
                                }
                            }}
                        />
                    </div>
                    <div className="adjust-timings-field">
                        <label className="adjust-timings-label">To stop</label>
                        <TreeSelect
                            className="adjust-timings-tree"
                            dropdownClassName="adjust-timings-tree-dropdown"
                            placeholder="Select to stop"
                            value={toStop}
                            treeDefaultExpandAll
                            showSearch
                            filterTreeNode={(input, node) => node.title.toLowerCase().includes(input.toLowerCase())}
                            treeData={getStopTreeData(citiesWithStops, isValidNumber(fromStop) ? fromStop : 0)}
                            onChange={(value) => setToStop(value)}
                        />
                    </div>
                </div>
                <div className="adjust-timings-field">
                    <label className="adjust-timings-label">Operation</label>
                    <div className="adjust-timings-operation">
                        <Select
                            defaultValue="+"
                            className="adjust-timings-op-select"
                            onChange={(value) => setOperation(value)}
                        >
                            <Option value="+">Add Time (+)</Option>
                            <Option value="-">Subtract Time (-)</Option>
                        </Select>
                        <InputNumber
                            min={0}
                            placeholder="Enter minutes"
                            className="adjust-timings-minutes"
                            onChange={(value) => setMinutes(value)}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const DayInputComponent = ({ value, onChange, showError, dayExits, isMobile }) => (
    <InputNumber
        className={`${showError && !dayExits ? "dayInput errorInput" : "dayInput"} ${isMobile ? "mobile-day-input" : ""}`}
        size="small"
        defaultValue={value}
        onChange={onChange}
        style={{ width: '80%' }}
    />
);

export const NewTimingTab = (props) => {

    let {
        scheduleId,
        tripId,
        travelDate,
        scheduleDescription,
        showUpdateBtns,
        selectedDate,
        importFrom,
        scheduleData,
        isStopsOpened,
        checkTripActionAllowed
    } = props;
        
    if(isValid(travelDate)){
        scheduleDescription = scheduleDescription + `(DOJ:${getReadableDate(travelDate)})`;
    }

    const [citiesWithStops,setCitiesWithStops]=useState([]);
    const [originalStops,setOriginalStops]=useState([]);
    const [existingLocations,setExistingLocations]=useState([]);
    const [standardStopsWithCities,setStandardStopsWithCities]=useState({});
    const [showError , setShowError] = useState(false);
    const travelApiDate = isValid(travelDate) ? getAPIDateFormat(travelDate) : null;
    const [currentSelectedDates, setCurrentSelectedDates] = useState(isValid(travelApiDate) ? [travelApiDate] : []);
    // Search page only: extra calendar dates (besides the opened trip's date) to apply the change to
    const [isMultiDayChange, setIsMultiDayChange] = useState(false);
    const [additionalDates, setAdditionalDates] = useState([]);
    const [isPermanentChange, setIsPermanentChange] = useState(false);
    const [isDaySpecificExits, setIsDaySpecificExits] = useState(false);
    const [isTimeAdjustmentVisible, setIsTimeAdjustmentVisible] = useState(false);
    const [expandedPanels, setExpandedPanels] = useState([]);
    const [isResetModalVisible, setIsResetModalVisible] = useState(false);
    const [resetTableData, setResetTableData] = useState([]);
    const [isNotifyPassengers, setIsNotifyPassengers] = useState(false);
    const [bookingConflictModal, setBookingConflictModal] = useState({
        visible: false,
        conflictsByDate: {},
        conflictDatesByCity: {},
        inactiveCityNames: [],
        pendingUpdate: null
    });
    // Single modal used both for creating a brand new stop (formDetails === null)
    // and for editing an existing stop's address (formDetails pre-filled).
    const [addressModal, setAddressModal] = useState({
        visible: false,
        formDetails: null,
        city: null,
        cityIndex: null,
        stopIndex: null
    });

    const dispatch = useDispatch();

    useEffect(()=>{
        if(importFrom === "SearchPage"){
            refetchDetails();
        }
    },[scheduleId,tripId]);

    useEffect(() => {
        // Check if any stop in originalStops has a tripId
        const hasTripId = originalStops.some(city => Array.isArray(city.tripIds) && city.tripIds.length > 0);
        setIsDaySpecificExits(hasTripId); // Set isDaySpecificExits based on the condition
    }, [originalStops]); // Dependency on originalStops

    const refetchDetails=()=>{
        setLoading(true);
        // Search page always shows the opened trip's stops; extra calendar dates only widen the update/reset.
        const fetchDates = importFrom === "SearchPage" ? [travelApiDate] : currentSelectedDates;
        getScheduleStopsByTripIdWithCities(scheduleId, tripId, fetchDates, onSuccess, onFailure);
    }

    const onAdditionalDatesChange = (dates) => {
        setAdditionalDates(dates);
        setCurrentSelectedDates([travelApiDate, ...dates]);
    }

    const onMultiDayToggle = (e) => {
        const checked = e.target.checked;
        setIsMultiDayChange(checked);
        if (!checked) {
            setAdditionalDates([]);
            setCurrentSelectedDates([travelApiDate]);
        }
    }

    const resetFromUI =()=>{
        setCitiesWithStops([...originalStops]);
    }

    const {
        isMobile
    }=useContext(DeviceContext);

    // Single source of truth for the column widths (out of 24) so the header and the
    // stop rows stay aligned. The stop name gets the lion's share of the width while
    // Time / Day / Main / Trip Close stay compact, on both desktop and mobile.
    const getSpan = (key) => {
        // Each column set sums to 24 (antd grid). Stop name takes the most space.
        const spans = {
            indent: isMobile ? 0 : 1,   // desktop: 1+10+4+2+3+4 = 24
            name:   isMobile ? 10 : 10,  // mobile:  0+10+6+2+3+3 = 24
            time:   isMobile ? 6 : 4,
            day:    isMobile ? 2 : 2,
            main:   isMobile ? 3 : 3,
            action: isMobile ? 3 : 4
        };
        return spans[key];
    };


    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const onSuccess=(data)=>{
        setCitiesWithStops(data.citiesWithStops);
        var obj2 = JSON.parse(JSON.stringify(data.citiesWithStops)); 
        setExistingLocations(getExistingLocations(obj2));
        setOriginalStops(obj2);
        setLoading(false);
    }
    
    const onFailure=(msg)=>{
        message.error(msg);
        setLoading(false);
    }

    const onClickStopCheckBox=(value,cityIndex,stopIndex)=>{
        citiesWithStops[cityIndex].stops[stopIndex].isActive = value;
        setCitiesWithStops([...citiesWithStops]);
    }

    const onClickStopEditCheckBox=(value,cityIndex,stopIndex)=>{
        citiesWithStops[cityIndex].stops[stopIndex].isEdit = value;
        setCitiesWithStops([...citiesWithStops]);
    }

    const closeAddressModal=()=>{
        setAddressModal({ visible: false, formDetails: null, city: null, cityIndex: null, stopIndex: null });
    }

    const onClickStopMapIcon=(stop)=>{
        // Map the stop's address details to the shape CreateStandardStopsPage expects so the
        // update address popup opens pre-filled. A non-empty drop_address makes the page show
        // separate Boarding / Drop sections (different addresses for pick and drop).
        const formDetails = {
            id: stop.selectedStopId,
            name: stop.displayName,
            city: stop.city,
            address: stop.address,
            landmark: stop.landmark,
            latitude: stop.latitude,
            longitude: stop.longitude,
            phone_number: stop.phoneNumber,
            landline_number: stop.landlineNumber,
            phone_number3: stop.phoneNumber3,
            drop_address: stop.dropAddress,
            drop_landmark: stop.dropLandmark,
            drop_latitude: stop.dropLatitude,
            drop_longitude: stop.dropLongitude
        };
        setAddressModal({ visible: true, formDetails, city: stop.city, cityIndex: null, stopIndex: null });
    }

    const renderStopMapIcon=(stop)=>{
        // Hide for rows without a selected stop, and for standard (shared) stops -
        // standard stops have no operator_code and their address is not editable here.
        if(!isValid(stop.selectedStopId) || stop.isStandardStop){
            return null;
        }
        return (
            <Tooltip title={stop.isPickDropDifferent ? "Different address for pickup & drop" : "Same address for pickup & drop"}>
                <span className="stop-map-icon-wrapper">
                    <Badge
                        className="stop-map-badge"
                        count={stop.isPickDropDifferent ? 2 : 0}
                        size="small"
                        offset={[-2, 2]}
                    >
                        <span
                            className="stop-map-icon-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClickStopMapIcon(stop);
                            }}
                        >
                            <EnvironmentOutlined />
                        </span>
                    </Badge>
                </span>
            </Tooltip>
        );
    }

    const updateStopsDate = (value, cityIndex, stopIndex, label, selectedStop=null) => {
  
            if (label === 'tripClosePoint' && value === 1) {
                // Reset all other tripClosePoints to 0
                citiesWithStops.forEach((city) => {
                    city.stops.forEach((stop) => {
                        stop.tripClosePoint = 0;
                    });
                });
            }

            if (label === 'selectedStopId' && citiesWithStops[cityIndex].stops[stopIndex].isNewStop) {
                if (selectedStop) {
                    // Get default phone numbers from global travels phone number
                    const phoneNumbers = getArrayfromString(global.travelsPhoneNumber);
                    const defaultPhoneNumber = phoneNumbers[0] || null;
                    const defaultLandlineNumber = phoneNumbers[1] || null;
                                        
                    citiesWithStops[cityIndex].stops[stopIndex] = {
                        ...citiesWithStops[cityIndex].stops[stopIndex],
                        selectedStopId: value,
                        city: selectedStop.city,
                        displayName: selectedStop.name,
                        isActive: 1,
                        isStop: true,
                        timing: citiesWithStops[cityIndex].stops[stopIndex].timing || null,
                        tripClosePoint: selectedStop.tripClosePoint || 0,
                        isBoarding: citiesWithStops[cityIndex].isBoarding || false,
                        isDrop: citiesWithStops[cityIndex].isDrop || false,
                        phoneNumber: isValid(selectedStop.data.phone_number) ? selectedStop.data.phone_number : defaultPhoneNumber,
                        landlineNumber: isValid(selectedStop.data.landline_number) ? selectedStop.data.landline_number : defaultLandlineNumber
                    };
                }
            } else {
                citiesWithStops[cityIndex].stops[stopIndex][label] = value;
            }
        setCitiesWithStops([...citiesWithStops]);
    };

    const removeStopFromUI=(cityIndex,stopIndex)=>{
        citiesWithStops[cityIndex].stops = deleteIndexValue(citiesWithStops[cityIndex].stops,stopIndex);
        setCitiesWithStops([...citiesWithStops]);
    }

    // const renderStandardStops=(city)=>{
    //     let standardStopsOptions =[];
    //     if(isValid(standardStopsWithCities[city])){
    //         let standardStops = standardStopsWithCities[city].standardStops;
    //         if(isValidArray(standardStops)&&standardStops.length>0){
    //         standardStops.map((address)=>{
    //             if(existingLocations.indexOf(address.name) == -1){
    //                 standardStopsOptions.push(<Option key = {address.id} name={address.name} id={address.id} value= {address.id} data={address}>{address.name}</Option>);
    //             }
    //         });
    //   }
    //   return standardStopsOptions;
    // }

    const printAdressLocation = (city) => {
        let normalStops = [] ;
        if(isValid(standardStopsWithCities)&&isValid(standardStopsWithCities[city])){
            let addressLocation = standardStopsWithCities[city].addressLocation;
            if(isValidArray(addressLocation)&&addressLocation.length>0){
                addressLocation.map((address) => {
                    normalStops.push(<Option key = {address.id} name={address.name} id={address.id} value= {address.id} data={address}>{address.name}</Option>);
                });
            }
        }
        return normalStops;
    }

    const printStandardStops = (city) =>{
      let standardStopsOptions =[];
      if(isValid(standardStopsWithCities)&&isValid(standardStopsWithCities[city])){
        let standardStops = standardStopsWithCities[city].standardStops;
        if(isValidArray(standardStops)&&standardStops.length>0){
            standardStops.map((address)=>{
            standardStopsOptions.push(<Option key = {address.id} name={address.name} id={address.id} value= {address.id} data={address}>{address.name}</Option>);
            });
        }
      }
      return standardStopsOptions;
    }

    const renderNewStopRow = (cityIndex, stopIndex, city, stop) => {
        let stopExits = false, dayExits = false, timeExits = false;
        if (isValid(stop.selectedStopId)) {
            stopExits = true;
        }
        if (isValidNumber(stop.day) && stop.day >= 0) {
            dayExits = true;
        }
        if (isValid(stop.timing)) {
            timeExits = true;
        }

        return (
            <div className="new-timing-tab-block">
                <Row className={'stop-row'} gutter={0} align="middle" justifyContent="space-around">
                    {isMobile ?null :<Col span={getSpan('indent')}></Col>}
                    <Col span={getSpan('name')} className="stop-name-col">
                        <Select
                            showSearch
                            optionFilterProp="children"
                            size="small"
                            placeholder="Select stop"
                            className={showError && !stopExits ? "selectStop errorInput" : "selectStop"}
                            value={isValid(stop.selectedStopId) ? stop.selectedStopId : null}
                            dropdownRender={menu => (
                                <div className="createStopDiv">
                                    {menu}
                                    <Divider style={{ margin: '8px 0' }} />
                                    <Button
                                        className="createStopBtn"
                                        size="small"
                                        onClick={() => {
                                            setAddressModal({ visible: true, formDetails: null, city, cityIndex, stopIndex });
                                        }}
                                    >
                                        Create New Stop
                                    </Button>
                                </div>
                            )}
                            onSelect={(value, data) => {
                                updateStopsDate(data.id, cityIndex, stopIndex, 'selectedStopId', data);
                            }}
                            style={{ width: '90%' }}
                        >
                            {printAdressLocation(city)}
                            <Select.OptGroup label="Standard stops">{printStandardStops(city)}</Select.OptGroup>
                        </Select>
                    </Col>
                    <Col span={getSpan('time')} className="time-col-in-stops">
                        <div style={{
                            width: isMobile ? '100%' : '130px',
                            marginRight: isMobile ? '4px' : '10px'
                        }}>
                            <TimePickerComponent
                                value={stop.timing}
                                onSelect={(date) => {
                                    let time = date.format("HH:mm:ss");
                                    updateStopsDate(time, cityIndex, stopIndex, 'timing');
                                }}
                                showError={showError}
                                timeExits={timeExits}
                                isMobile={isMobile}
                            />
                        </div>
                    </Col>
                    <Col span={getSpan('day')} className="day-col">
                        <div style={{ width: isMobile ? '32px' : '30px' }}>
                            <DayInputComponent
                                value={stop.day + 1}
                                onChange={(value) => {
                                    updateStopsDate(value - 1, cityIndex, stopIndex, 'day');
                                }}
                                showError={showError}
                                dayExits={dayExits}
                                isMobile={isMobile}
                            />
                        </div>
                    </Col>
                    <Col span={getSpan('main')} className="main-stop-col">
                        <div style={{
                            width: isMobile ? '32px' : '30px'
                        }}>
                            {stop.isMainStop ? (
                                <CheckSquareFilled
                                    style={{
                                        fontSize: '18px',
                                        color: '#52c41a'
                                    }}
                                />
                            ) : null}
                        </div>
                    </Col>
                    <Col span={getSpan('action')} className="action-col">
                        <div className="action-wrapper">
                            <Button
                                type="text"
                                className="outline-button edit-col"
                                onClick={() => {
                                    removeStopFromUI(cityIndex, stopIndex);
                                }}
                            >
                                <DeleteOutlined style={{ fontSize: '16px' }} />
                            </Button>
                        </div>
                    </Col>
                </Row>
                    <Row className="mobile-phone-row margin-bottom-10">
                        <Col offset={getSpan('indent')}>
                            <InputNumber
                                placeholder="Phone Number"
                                className={showError && !dayExits ? "phoneInput errorInput" : "phoneInput"}
                                size="small"
                                value={stop.phoneNumber}
                                onChange={(value) => {
                                    updateStopsDate(value, cityIndex, stopIndex, 'phoneNumber');
                                }}
                                style={{ width: '100%', minWidth: '100px' }}
                            />
                        </Col>
                    </Row>
            </div>
        );
    };

    const renderRow = (stop, cityIndex, stopIndex) => {
        let className = '';
        
        if (stop.isActive == 0) {
            className = 'inactive-stop';
        }

        // Check if fields are valid when in edit mode
        const timeExits = isValid(stop.timing);
        const dayExits = isValidNumber(stop.day) && stop.day >= 0;
        const showFieldError = showError && stop.isEdit;

        const renderTimingColumn = () => {
            if (stop.isEdit) {
                return (
                    <div style={{
                        width: isMobile ? '100%' : '130px',
                        marginRight: isMobile ? '4px' : '10px'
                    }}>
                        <TimePickerComponent
                            value={stop.timing}
                            onSelect={(date) => {
                                let time = date.format("HH:mm:ss");
                                updateStopsDate(time, cityIndex, stopIndex, 'timing');
                            }}
                            showError={showFieldError}
                            timeExits={timeExits}
                            isMobile={isMobile}
                        />
                    </div>
                );
            }

            return (
                <div style={{
                    width: isMobile ? '100%' : '130px',
                    marginRight: isMobile ? '4px' : '10px'
                }}>
                    {getTimeStampInReadableFormat(stop.timing)}
                    {Array.isArray(stop.timings) && stop.timings.length > 1 && (
                        <Tooltip 
                            title={stop.timings.map(t => 
                                `${Array.isArray(t.tripStartDates) ? 
                                    t.tripStartDates.map(date => date).join(', ') : 
                                    t.tripStartDates}: ${getTimeStampInReadableFormat(t.timing)}`
                            ).join('\n')}
                            placement="right"
                        >
                            <div style={{ color: '#1B6BE3', fontSize: '12px' }}> (Multiple)</div>
                        </Tooltip>
                    )}
                </div>
            );
        };

        return (
            <Row className={`stop-row ${className}`} gutter={0} align="middle">
                {isMobile ?null // Remove the initial spacing for mobile
                :
                <Col span={getSpan('indent')}></Col>
                }
                <Col span={getSpan('name')} className="stop-name-col">
                    <div className="stop-city-col">
                        <Row className="description-row" align="middle" wrap={false}>
                            <Col flex="none">
                                {renderCheckBox(stop.isActive, cityIndex, stopIndex)}
                            </Col>
                            <Col flex="auto">
                                <span style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <StopNameDisplay
                                        displayName={stop.displayName}
                                        isBoarding={stop.isBoarding}
                                        isDrop={stop.isDrop}
                                    />
                                    {renderStopMapIcon(stop)}
                                </span>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={getSpan('time')} className="time-col-in-stops" >
                        {renderTimingColumn()}
                </Col>
                <Col span={getSpan('day')} className="day-col">
                    <div style={{ 
                        width: isMobile ? '32px' : '30px'
                    }}>
                        {stop.isEdit ?
                            <DayInputComponent
                                value={stop.day + 1}
                                onChange={(value) => {
                                    updateStopsDate(value - 1, cityIndex, stopIndex, 'day');
                                }}
                                showError={showFieldError}
                                dayExits={dayExits}
                                isMobile={isMobile}
                            />
                            :
                            <div className="day-display">
                                {stop.day + 1}
                            </div>
                        }
                    </div>
                </Col>
                <Col span={getSpan('main')} className="main-stop-col">
                    <div style={{
                        width: isMobile ? '32px' : '30px'
                    }}>
                        <Switch
                            size="small"
                            checked={stop.isMainStop}
                            onChange={(checked) => {
                                const updatedStops = updateMainStopForCity(citiesWithStops, cityIndex, stopIndex, checked);
                                setCitiesWithStops(updatedStops);
                            }}
                            disabled={!stop.isActive}
                        />
                    </div>
                </Col>
                <Col span={getSpan('action')} className="action-col">
                    <div className="action-wrapper">
                        <div className="trip-close-checkbox">
                            {stop.isEdit ?
                                <Checkbox
                                    checked={stop.tripClosePoint === 1}
                                    onChange={(e) => {
                                        updateStopsDate(e.target.checked ? 1 : 0, cityIndex, stopIndex, 'tripClosePoint');
                                    }}
                                />
                                :
                                (stop.tripClosePoint === 1 ?
                                    <div className="tick-icon">
                                        <Icon component={() => (<img src={TicMarkIcon} style={{width:'14px'}} />)} />
                                    </div>
                                    :
                                    <div className="tick-icon-placeholder"></div>
                                )
                            }
                        </div>
                        {isShowCheckBox && !stop.isEdit &&
                            <Button
                                type="text" 
                                className={`outline-button edit-col ${isMobile ? 'edit-col-mobile' : ''}`} 
                                onClick={() => {
                                    onClickStopEditCheckBox(true, cityIndex, stopIndex)
                                }}
                            >
                                <EditOutlined style={{ fontSize: '16px' }} />
                            </Button>
                        }
                    </div>
                </Col>
            </Row>
        )
    }

    const separateAddressLocation=(addressLocations)=>{
        let addressLocation = [];
        let standardStops = [];
        addressLocations.forEach(location=>{
            if(isValid(location.operator_code)){
                addressLocation.push(location);
            }else{
                standardStops.push(location);
            }
        });
        
        return {addressLocation,standardStops};
    }   

    const reSetStandaredCities=(city,cityIndex)=>{
        dispatch(getAddressLocations([city],true,(data)=>{
            standardStopsWithCities[citiesWithStops[cityIndex].city] = separateAddressLocation(data.addressLocations);
            setStandardStopsWithCities({...standardStopsWithCities});
            closeAddressModal();
        },(errMsg)=>{
            message.error(errMsg);
        }));
    }

    const onClickAddStop=(cityIndex,citystop)=>{
        citiesWithStops[cityIndex].stops.push({isNewStop:true,isBoarding:citystop.isBoarding,isDrop:citystop.isDrop});
        if(!isValidArray(standardStopsWithCities[citiesWithStops[cityIndex].displayName])){
           reSetStandaredCities(citiesWithStops[cityIndex].displayName,cityIndex);
        }
        setCitiesWithStops([...citiesWithStops]);
    }

    const handleCityActiveChange = (value, cityIndex) => {
        const updatedCities = [...citiesWithStops];
        updatedCities[cityIndex].isActive = value;
        // Update all stops under this city
        updatedCities[cityIndex].stops.forEach(stop => {
            stop.isActive = value;
        });
        setCitiesWithStops(updatedCities);
    }

    const renderAllCitiesWithStops=()=>{
        let components=[];
        if(isValidArray(citiesWithStops)&&citiesWithStops.length>0){

            citiesWithStops.forEach((citystop,cityIndex)=>{
                let {
                    stops,
                    displayName
                } = citystop;
                
                if(isValidArray(stops)&&stops.length>0){
                    let collapseAbleComponent=[];
                    stops.forEach((stop,stopIndex)=>{
                        if(stop.isNewStop == true){
                            collapseAbleComponent.push(renderNewStopRow(cityIndex,stopIndex,displayName,stop));
                        }else{
                            collapseAbleComponent.push(renderRow(stop,cityIndex,stopIndex));
                        }
                    });
                    components.push(<Collapse 
                    collapsible={displayName} 
                    ghost 
                    className="stop-collapse new-timing-body"
                    activeKey={expandedPanels}
                    onChange={handlePanelChange}
                    expandIcon={({ isActive }) => (
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            <CityCheckbox 
                                isActive={citystop.isActive}
                                cityIndex={cityIndex}
                                onToggle={handleCityActiveChange}
                                isShowCheckBox={isShowCheckBox}
                            />
                            {isActive ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
                        </span>
                    )}
                    >
                                        <Panel
                                        key={cityIndex}
                                        header={
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                {displayName}
                                                {citystop.isTemporary &&
                                                    <Typography.Text type="warning" italic style={{ marginLeft: '6px' }}>(temporary)</Typography.Text>
                                                }
                                            </span>
                                        }
                                        >
                                            {collapseAbleComponent}
                                            <Row>
                                                <Col span={getSpan('indent')}>

                                                </Col>
                                                <Col>
                                                {isShowCheckBox &&
                                                <div>
                                                    <Button className="addStopBtn" size="small" onClick={()=>{
                                                        onClickAddStop(cityIndex,citystop);
                                                    }}>Add stop</Button>
                                                </div>
                                                }
                                                </Col>
                                            </Row>

                                        </Panel>
                                    </Collapse>);
                }
            })
        }
        return components;
    }

    const onClickReset=()=>{
        if(isDaySpecificExits){
            setLoading(true);
            // Extract unique tripIds from originalStops
            const uniqueTripIds = [...new Set(
                originalStops
                    .filter(city => Array.isArray(city.tripIds) && city.tripIds.length > 0)
                    .flatMap(city => city.tripIds)
            )];
            getTicketAlertContentForResetStops(uniqueTripIds, scheduleId, currentSelectedDates, (data) => {
                setLoading(false);
                setResetTableData(data.tableData);
                setIsNotifyPassengers(false);
                setIsResetModalVisible(true);
            }, () => {
                setLoading(false);
                message.error("Failed to get reset stops data!");
            });
        }else{
            showConfirm(()=>{
                resetFromUI();
            },"Reset","Are you sure to reset to original time?");
        }
    }

    const handleResetProceed = () => {
        setIsResetModalVisible(false);
        setLoading(true);
        // Search page already has the tripId, but the server ignores travelDates when tripId is
        // given - so pass it only for a single-date reset; multi-date resolves trips from
        // scheduleId + dates like the schedule page.
        const resetTripId = importFrom === "SearchPage" && currentSelectedDates.length <= 1 ? tripId : null;
        resetToDefaultTimings(scheduleId, currentSelectedDates, isNotifyPassengers, resetTripId, resetSuccess, resetFailure);
    }

    const handleResetCancel = () => {
        setIsResetModalVisible(false);
        setResetTableData([]);
        setIsNotifyPassengers(false);
    }

    const resetSuccess=()=>{
        message.success("Successfully removed day specific timings!");
        refetchDetails(); 
    }

    const resetFailure=()=>{
        message.error("Failed removed day specific timings!");
        setLoading(false);
    }

    const onClickUpdateTimings = () => {
        // Validate all fields first
        let hasError = false;
        let allBoardingStopsInactive = true;

        try {
            citiesWithStops.forEach(city => {
                city.stops.forEach(stop => {
                    if (stop.isNewStop) {
                        // Check mandatory fields for new stops
                        if (!stop.selectedStopId || !isValid(stop.phoneNumber)) {
                            hasError = true;
                        }
                    }                
                    if(!stop.timing || !isValidNumber(stop.day) || stop.day < 0){
                        hasError = true;
                    }
                    // Check if any boarding stop is active
                    if (city.isBoarding && stop.isActive) {
                        allBoardingStopsInactive = false;
                    }
                });
            });

            if (hasError) {
                setShowError(true);
                message.error("Please fill all mandatory fields (Stop, Time, Day, and Phone Number)");
                return;
            }

            if (allBoardingStopsInactive) {
                message.error("At least one boarding stop must be active");
                return;
            }

            const originDayError = getOriginMainStopDayError(citiesWithStops, originalStops);
            if (originDayError) {
                setShowError(true);
                message.error(originDayError);
                return;
            }

            const { changedStops, firstActiveCity, lastActiveCity,firstCityStartTime,lastCityEndTime } = getChangedStops(citiesWithStops,isPermanentChange);

            if(isPermanentChange||currentSelectedDates.length>0){
                const callUpdate = (bookingConflictDatesByCity = null) => {
                    setLoading(true);
                    updateStopTimingsOfTrip(
                        scheduleId,
                        currentSelectedDates,
                        changedStops,
                        isPermanentChange,
                        firstActiveCity,
                        lastActiveCity,
                        firstCityStartTime,
                        lastCityEndTime,
                        updateSuccess,
                        updateFailure,
                        bookingConflictDatesByCity
                    );
                };

                const inactiveCityNames = [];
                if (isValid(changedStops)) {
                    Object.keys(changedStops).forEach(cityName => {
                        const cityInfo = changedStops[cityName] && changedStops[cityName].city;
                        if (cityInfo && cityInfo.isActive === false) {
                            inactiveCityNames.push(cityName);
                        }
                    });
                }

                if (inactiveCityNames.length > 0) {
                    const datesForValidation = isPermanentChange ? [] : currentSelectedDates;
                    setLoading(true);
                    getStopBookingConflictsForFutureDates(
                        scheduleId,
                        inactiveCityNames,
                        datesForValidation,
                        (data) => {
                            setLoading(false);
                            const conflictsByDate = (data && data.conflictsByDate) || {};
                            const conflictDatesByCity = (data && data.conflictDatesByCity) || {};
                            if (Object.keys(conflictsByDate).length > 0) {
                                setBookingConflictModal({
                                    visible: true,
                                    conflictsByDate,
                                    conflictDatesByCity,
                                    inactiveCityNames,
                                    pendingUpdate: () => callUpdate(conflictDatesByCity)
                                });
                            } else {
                                callUpdate(null);
                            }
                        },
                        (errMsg) => {
                            setLoading(false);
                            message.error(errMsg || "Failed to validate stop deletion against bookings");
                        }
                    );
                } else {
                    callUpdate(null);
                }
            }else{
                message.warning("Please select atleat one day or permanent change");
            }
            setShowError(false);
        } catch (error) {
            message.error(error.message);
            setShowError(true);
        }
    };

    const handleBookingConflictCancel = () => {
        setBookingConflictModal({
            visible: false,
            conflictsByDate: {},
            conflictDatesByCity: {},
            inactiveCityNames: [],
            pendingUpdate: null
        });
    };

    const handleBookingConflictContinue = () => {
        const pending = bookingConflictModal.pendingUpdate;
        handleBookingConflictCancel();
        if (typeof pending === 'function') {
            pending();
        }
    };

    const updateSuccess=()=>{
        setLoading(false);
        message.success("Successfully updated timings!");
        refetchDetails(); 
    }

    const updateFailure=(errMsg)=>{
        message.error(errMsg);
        setLoading(false);
    }

    // Shared trips pass the sharing agent's action check; own trips use the logged in user's
    let isShowCheckBox=isValid(checkTripActionAllowed)?(checkTripActionAllowed(UPDATE_IN_NEW_TIME_TAB)?true:false):showCheckBoxForEdit();

    const renderCheckBox = (value=true, cityIndex, stopIndex) => {
        if (isShowCheckBox) {            
            if (!value) {
                return (
                    <MinusSquareFilled 
                        className="marginRight"
                        style={{ 
                            color: '#ff4d4f',
                            fontSize: '18px',  // Match default antd checkbox size
                            cursor: 'pointer'
                        }}
                        onClick={(e) => {
                            onClickStopCheckBox(true, cityIndex, stopIndex);
                        }}
                    />
                );
            }
            return (
                <CheckSquareFilled 
                    className="marginRight default-checkbo-btn"
                    style={{ 
                        fontSize: '18px',  // Match default antd checkbox size
                        cursor: 'pointer'
                    }}
                    onClick={(e) => {
                        onClickStopCheckBox(false, cityIndex, stopIndex);
                    }}
                />
            );
        }
        return null;
    }

    const adjustTimings = (operation, minutes, fromStop, toStop) => {
        // fromStop/toStop are global (route-ordered) stop indices. Only stops whose
        // position falls within [fromStop, toStop] are adjusted. When the range is not
        // provided, fall back to adjusting every stop.
        const hasRange = isValidNumber(fromStop) && isValidNumber(toStop);
        let globalIndex = -1;
        const updatedStops = citiesWithStops.map(city => ({
            ...city,
            stops: city.stops.map(stop => {
                globalIndex += 1;
                if (!stop.timing) return stop;
                if (hasRange && (globalIndex < fromStop || globalIndex > toStop)) {
                    return stop;
                }

                // Create independent copies of the time
                const currentTime = moment(stop.timing, 'HH:mm:ss');
                const newTime = moment(stop.timing, 'HH:mm:ss');
                
                // Apply the operation to newTime
                if (operation === '+') {
                    newTime.add(minutes, 'minutes');
                } else {
                    newTime.subtract(minutes, 'minutes');
                }
                
                // Calculate day adjustment based on time crossing midnight
                let dayAdjustment = 0;
                const currentHour = currentTime.hour();
                const newHour = newTime.hour();
                
                if (operation === '+') {
                    if (currentHour > newHour || (currentHour === newHour && currentTime.minute() > newTime.minute())) {
                        dayAdjustment = 1;
                    }
                } else {
                    if (currentHour < newHour || (currentHour === newHour && currentTime.minute() < newTime.minute())) {
                        dayAdjustment = -1;
                    }
                }
                
                return {
                    ...stop,
                    timing: newTime.format('HH:mm:ss'),
                    day: Math.max(0, (stop.day || 0) + dayAdjustment) // Ensure day doesn't go below 0
                };
            })
        }));
        const originDayError = getOriginMainStopDayError(updatedStops, originalStops);
        if (originDayError) {
            message.error(originDayError);
            return false;
        }
        setCitiesWithStops(updatedStops);
        return true;
    };

    // Temporary cities live on the day they were added. An update that reaches other
    // dates now carries them along, so say which cities that is before the user hits
    // Update - on a permanent change they also stop being temporary.
    const getTemporaryCityNames = () => {
        if(!isValidArray(citiesWithStops)){
            return [];
        }
        return citiesWithStops
            .filter(city => city.isTemporary && city.isActive)
            .map(city => city.displayName);
    }

    const renderTemporaryCityNote = () => {
        const temporaryCityNames = getTemporaryCityNames();
        if(temporaryCityNames.length === 0){
            return null;
        }
        const cityList = temporaryCityNames.join(', ');
        let note = null;
        if(isPermanentChange){
            note = `${cityList} will be added to all future dates and will no longer be temporary.`;
        }else if(currentSelectedDates.length > 1){
            note = `${cityList} will be copied to all the selected dates.`;
        }
        if(!isValid(note)){
            return null;
        }
        return (
            <Row justify="center">
                <Col>
                    <Text type="warning" italic>{note}</Text>
                </Col>
            </Row>
        );
    }

    const renderActionButtons = () => (
        <>
        <Row justify="center" align="middle" gutter={[16,16]}>
            <Col>
                <Button
                    icon={<PlusOutlined />}
                    onClick={() => setIsTimeAdjustmentVisible(true)}
                >
                    Adjust Times
                </Button>
            </Col>
            <Col>
                {(isDaySpecificExits||showResetBtn(citiesWithStops))&&currentSelectedDates.length>0?
                    <Button 
                        className="exit-btn"
                        onClick={onClickReset}
                    >Reset To Original Time</Button>
                    :null
                }
            </Col>
            <Col style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: 8 }}>Permanent Change</span>
                <Switch 
                    checked={isPermanentChange}
                    onChange={(checked) => setIsPermanentChange(checked)}
                    style={{ marginRight: 16 }}
                />
            </Col>
            <Col>
                <Button onClick={onClickUpdateTimings}>
                    Update
                </Button>
            </Col>
        </Row>
        {renderTemporaryCityNote()}
        </>
    );
    const updateMainStopForCity = (citiesWithStops, cityIndex, stopIndex, value) => {
        return citiesWithStops.map((city, cIndex) => {
            if (cIndex === cityIndex) {
                return {
                    ...city,
                    stops: city.stops.map((stop, sIndex) => ({
                        ...stop,
                        isMainStop: sIndex === stopIndex ? value : false
                    }))
                };
            }
            return city;
        });
    };

    const handleExpandAll = () => {
        const allPanelKeys = citiesWithStops.map((_, index) => index.toString());
        setExpandedPanels(allPanelKeys);
    };

    const handleCollapseAll = () => {
        setExpandedPanels([]);
    };

    const handlePanelChange = (keys) => {
        setExpandedPanels(keys);
    };

    return (
        <ZoomComponent isMobile={isMobile}>
            <div className="new-timing-root">
                <Row>
                    <Col>
                        <Title level={3}>
                            Manage Stops
                        </Title>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Title level={5}>
                            {`${scheduleDescription}`}
                        </Title>
                    </Col>
                </Row>
                {/* Selecting extra dates is an edit affordance, so it follows the same
                    permission as the stop update buttons below. */}
                {showUpdateBtns && isShowCheckBox && isValid(scheduleId) && importFrom === "SearchPage" && (
                    <div className="stops-multi-day">
                        <Checkbox checked={isMultiDayChange} onChange={onMultiDayToggle}>
                            Change stops for multiple days
                        </Checkbox>
                        {isMultiDayChange && (
                            <div className="stops-multi-day-calendar-wrapper">
                                <MultiDayFareCalendar
                                    scheduleId={scheduleId}
                                    travelDate={travelDate}
                                    additionalDates={additionalDates}
                                    onAdditionalDatesChange={onAdditionalDatesChange}
                                    onReset={() => onAdditionalDatesChange([])}
                                />
                            </div>
                        )}
                    </div>
                )}
                {isValid(scheduleId) && importFrom === "schedulePage" && (
                    <Row gutter={[16, 16]} align="middle">
                        <Col flex="auto">
                            <ScheduleCalendar 
                                selectedDate={selectedDate || travelDate || new Date()}
                                onDatesChange={setCurrentSelectedDates}
                                showLegend={true}
                                scheduleData={scheduleData}
                                loadCalendarData={isStopsOpened}
                                renderGetStops={()=>{
                                    return(
                                        <Row gutter={[16,16]}>
                                            <Col>
                                                <Button 
                                                    type="primary"
                                                    disabled={currentSelectedDates.length === 0}
                                                    onClick={() => {
                                                        if (currentSelectedDates.length === 0) {
                                                            message.warning('Please select dates first');
                                                            return;
                                                        }else if(currentSelectedDates.length>1){
                                                            message.warning("Only one date is allowed before getting stop details");
                                                            return;
                                                        }   
                                                        refetchDetails();
                                                    }}
                                                >
                                                    Get Stops
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button 
                                                    type="primary"
                                                    disabled={currentSelectedDates.length > 0}
                                                    onClick={() => {
                                                        refetchDetails();
                                                    }}
                                                >
                                                    Get default stops
                                                </Button>
                                            </Col>
                                        </Row>
                                    )   
                                }}
                            />
                        </Col>
                    </Row>
                )}

                {/* Only show stops section and buttons if citiesWithStops has data */}
                {isValidArray(citiesWithStops) && citiesWithStops.length > 0 && (
                    <>
                        <Row className="heading-new-timing" align="middle">
                            {isMobile ? null : <Col span={getSpan('indent')}></Col>}
                            <Col span={getSpan('name')} style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: 8, cursor: 'pointer', fontSize: 18 }}
                                    onClick={() => {
                                        if (expandedPanels.length === citiesWithStops.length) {
                                            handleCollapseAll();
                                        } else {
                                            handleExpandAll();
                                        }
                                    }}
                                >
                                    {expandedPanels.length === citiesWithStops.length ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
                                </span>
                                <div className="city-col">{isMobile ? "Stop" : "Stop · location"}</div>
                            </Col>
                            <Col span={getSpan('time')}>
                                <div className="heading-col-label">
                                    Time
                                </div>
                            </Col>
                            <Col span={getSpan('day')}>
                                <div className="heading-col-label">
                                    Day
                                </div>
                            </Col>
                            <Col span={getSpan('main')}>
                                <div className="heading-col-label">
                                    Main
                                </div>
                            </Col>
                            <Col span={getSpan('action')}>
                                <div className="heading-col-label">
                                    {isMobile ? "TC" : "Trip Close"}
                                </div>
                            </Col>
                        </Row>
                        <Divider className="dividerCol" />
                        <div className="new-timing-body">
                            {renderAllCitiesWithStops()}
                        </div>
                        {showUpdateBtns && isShowCheckBox && renderActionButtons()}
                    </>
                )}

                <TimeAdjustmentModal
                    visible={isTimeAdjustmentVisible}
                    onClose={() => setIsTimeAdjustmentVisible(false)}
                    onApply={adjustTimings}
                    citiesWithStops={citiesWithStops}
                />
                <Modal
                    title="Reset To Original Time"
                    visible={isResetModalVisible}
                    onCancel={handleResetCancel}
                    footer={[
                        <Button key="cancel" onClick={handleResetCancel}>
                            Cancel
                        </Button>,
                        <Button key="proceed" type="primary" onClick={handleResetProceed}>
                            Proceed
                        </Button>
                    ]}
                    width={700}
                >
                    <div>
                        <Text>The following stops timings are changing. Are you sure you want to proceed?</Text>
                        <Table
                            dataSource={resetTableData}
                            columns={[
                                {
                                    title: 'Stops',
                                    dataIndex: 'stopName',
                                    key: 'stopName',
                                },
                                {
                                    title: 'Passengers',
                                    dataIndex: 'passengers',
                                    key: 'passengers',
                                    align: 'center',
                                },
                                {
                                    title: 'Current Time',
                                    dataIndex: 'currentTime',
                                    key: 'currentTime',
                                    render: (text, record) => {
                                        if (Array.isArray(record.currentTimes) && record.currentTimes.length > 1) {
                                            return (
                                                <Tooltip 
                                                    title={record.currentTimes.map(t => getTimeStampInReadableFormat(t)).join(', ')}
                                                    placement="top"
                                                >
                                                    <span style={{ color: '#1B6BE3', cursor: 'pointer' }}>Multiple</span>
                                                </Tooltip>
                                            );
                                        }else{
                                            if(isValid(record.currentTimes)&&record.currentTimes.length == 1){
                                                return getTimeStampInReadableFormat(record.currentTimes[0]);
                                            }
                                        }
                                        return null;
                                    },
                                    align: 'center',
                                },
                                {
                                    title: 'New Time',
                                    dataIndex: 'newTime',
                                    key: 'newTime',
                                    render: (text) => getTimeStampInReadableFormat(text),
                                    align: 'center',
                                }
                            ]}
                            pagination={false}
                            rowKey={(record, index) => index}
                            size="small"
                            style={{ marginTop: 16, marginBottom: 16 }}
                        />
                        <Checkbox 
                            checked={isNotifyPassengers}
                            onChange={(e) => setIsNotifyPassengers(e.target.checked)}
                        >
                            Notify Passengers of time change
                        </Checkbox>
                    </div>
                </Modal>
                <Modal
                    title={null}
                    className="createNewStopModal"
                    visible={addressModal.visible}
                    width="95vw"
                    onOk={closeAddressModal}
                    onCancel={closeAddressModal}
                    centered={true}
                    footer={null}
                    destroyOnClose={true}
                    cancelButtonProps={{className:"exit-btn"}}
                >
                    {addressModal.visible &&
                        <div>
                            <CreateStandardStopsPage
                                fromModal={true}
                                isAddressBook={true}
                                selectedCity={addressModal.formDetails ? addressModal.formDetails.city : addressModal.city}
                                formDetailsFromprops={addressModal.formDetails}
                                operatorCode={global.operatorCode}
                                onSuccessRefresh={(id)=>{
                                    if (addressModal.formDetails) {
                                        // edited an existing stop's address
                                        closeAddressModal();
                                        refetchDetails();
                                    } else {
                                        // created a brand new stop -> link it into the selected row
                                        reSetStandaredCities(addressModal.city, addressModal.cityIndex);
                                        updateStopsDate(id, addressModal.cityIndex, addressModal.stopIndex, 'selectedStopId');
                                    }
                                }}
                                onFailureRefresh={(errMsg)=>{
                                    message.error(errMsg);
                                }}
                                cancelModal={closeAddressModal}
                            />
                        </div>
                    }
                </Modal>
                <BookingConflictModal
                    visible={bookingConflictModal.visible}
                    inactiveCityNames={bookingConflictModal.inactiveCityNames}
                    conflictsByDate={bookingConflictModal.conflictsByDate}
                    onCancel={handleBookingConflictCancel}
                    onContinue={handleBookingConflictContinue}
                />
            </div>
        </ZoomComponent>
    )
}

const TYPE_BADGE_STYLE = {
    color: 'white',
    padding: '0 6px',
    borderRadius: '2px',
    fontSize: '12px',
    marginRight: '4px',
    display: 'inline-block'
};

const BoardingBadge = () => (
    <span style={{ ...TYPE_BADGE_STYLE, backgroundColor: '#1890ff' }}>B</span>
);

const DropBadge = () => (
    <span style={{ ...TYPE_BADGE_STYLE, backgroundColor: '#52c41a' }}>D</span>
);

const formatJoinedCityNames = (cityNames) => {
    if (!Array.isArray(cityNames) || cityNames.length === 0) {
        return '';
    }
    if (cityNames.length === 1) {
        return cityNames[0];
    }
    if (cityNames.length === 2) {
        return `${cityNames[0]} & ${cityNames[1]}`;
    }
    return `${cityNames.slice(0, -1).join(', ')} & ${cityNames[cityNames.length - 1]}`;
};

const formatConflictDateLabel = (apiDate) => {
    const parsed = moment(apiDate, 'YYYY-MM-DD');
    if (parsed.isValid()) {
        return parsed.format('MMM D');
    }
    return apiDate;
};

const BookingConflictModal = ({ visible, inactiveCityNames, conflictsByDate, onCancel, onContinue }) => {
    const joinedNames = formatJoinedCityNames(inactiveCityNames);
    const sortedDates = Object.keys(conflictsByDate || {}).sort();

    return (
        <Modal
            title="Existing Bookings on Future Dates"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="continue" type="primary" onClick={onContinue}>
                    Continue
                </Button>
            ]}
            width={600}
        >
            <div>
                <p>
                    This action removes <strong>{joinedNames}</strong> from this trip.
                    But there are tickets booked to/from <strong>{joinedNames}</strong> on the following days:
                </p>
                <div style={{ marginTop: 12, marginBottom: 12 }}>
                    {sortedDates.map(dateKey => {
                        const cityMap = conflictsByDate[dateKey] || {};
                        const cityNames = Object.keys(cityMap);
                        return (
                            <div key={dateKey} style={{ marginBottom: 10 }}>
                                <div style={{ fontWeight: 600 }}>{formatConflictDateLabel(dateKey)}:</div>
                                <ul style={{ marginTop: 4, marginBottom: 4, paddingLeft: 20 }}>
                                    {cityNames.map(cityName => {
                                        const counts = cityMap[cityName] || {};
                                        const parts = [];
                                        if (counts.boardingCount > 0) {
                                            parts.push(
                                                <span key="b" style={{ marginRight: 8 }}>
                                                    <BoardingBadge />- {counts.boardingCount}
                                                </span>
                                            );
                                        }
                                        if (counts.dropCount > 0) {
                                            parts.push(
                                                <span key="d" style={{ marginRight: 8 }}>
                                                    <DropBadge />- {counts.dropCount}
                                                </span>
                                            );
                                        }
                                        return (
                                            <li key={cityName}>
                                                <strong>{cityName}</strong> - {parts}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        );
                    })}
                </div>
                <p>
                    If you continue, then on the above mentioned days alone,
                    <strong> {joinedNames}</strong> will not be removed.
                </p>
            </div>
        </Modal>
    );
};